module.exports = __webpack_public_path__ + "static/img/pic-shujuk.b493fde0.png";